import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  private _loading$ = new BehaviorSubject<boolean>(false);
  private requestCounter = 0;

  get loading$(): Observable<boolean> {
    return this._loading$.asObservable().pipe(debounceTime(300));
  }

  show() {
    this.requestCounter++;
    this._loading$.next(true);
  }

  hide() {
    this.requestCounter--;
    if (this.requestCounter <= 0) {
      this.requestCounter = 0;
      this._loading$.next(false);
    }
  }
}
